import React from 'react';

import type { Redirect } from '../../../../../../../types/Cashier';
import NativeAppLink from '../../../../../../NativeAppLink/NativeAppLink';
import CommonLayout from '../CommonLayout/CommonLayout';

import { TXTWCL_I_am_on_a_mobile_device } from './TabletLayout.messages.json';

interface Props {
  redirectUrl: Redirect;
  payconiqColor: string;
  qrCodeData?: string;
  remainTime: JSX.Element;
  onFallback: Function;
  onIgnored: Function;
}

const TabletLayout = ({
  redirectUrl,
  payconiqColor,
  qrCodeData,
  remainTime,
  onFallback,
  onIgnored
}: Props) => (
  <>
    <CommonLayout payconiqColor={payconiqColor} qrCodeData={qrCodeData} remainTime={remainTime} />
    <NativeAppLink
      variant="text"
      href={redirectUrl.url}
      onFallback={onFallback}
      onIgnored={onIgnored}
      translation={TXTWCL_I_am_on_a_mobile_device}
    />
  </>
);

export default TabletLayout;
